import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { insights } from '../data/siteData';
import './Insights.css';

const Insights = () => {
  const [submitted, setSubmitted] = useState(false);
  const articles = insights.slice(0, 3);

  return (
    <section className="insights" id="insights">
      <div className="section-container">
        <motion.div
          className="insights-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="insights-header-left">
            <span className="section-label">INSIGHTS & THOUGHT LEADERSHIP</span>
            <h2 className="section-title">
              Expert Analysis &
              <br />
              <span className="title-accent">Market Intelligence</span>
            </h2>
          </div>
          <div className="insights-header-right">
            <p>
              Stay informed with cutting-edge insights, market analysis, and legal
              perspectives from our global team of experts.
            </p>
            <Link to="/insights" className="view-all-btn">
              View All Insights
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M3 9H15M15 9L10 4M15 9L10 14" stroke="currentColor" strokeWidth="1.5" />
              </svg>
            </Link>
          </div>
        </motion.div>

        <div className="insights-grid">
          {articles.map((article, index) => (
            <motion.article
              key={article.title}
              className="insight-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -10 }}
            >
              <div className="insight-image">
                <div className="insight-emoji">{article.icon}</div>
                <span className="insight-category">{article.category}</span>
              </div>
              <div className="insight-content">
                <div className="insight-meta">
                  <span className="insight-date">{article.date}</span>
                  <span className="meta-divider">|</span>
                  <span className="insight-read-time">{article.readTime}</span>
                </div>
                <h3 className="insight-title">{article.title}</h3>
                <p className="insight-excerpt">{article.excerpt}</p>
                <Link to={`/insights/${article.slug}`} className="insight-link">
                  Read Article
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M3 8H13M13 8L8 3M13 8L8 13" stroke="currentColor" strokeWidth="1.5" />
                  </svg>
                </Link>
              </div>
            </motion.article>
          ))}
        </div>

        <motion.div
          className="newsletter-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <div className="newsletter-content">
            <div className="newsletter-left">
              <h3>Subscribe to Our Newsletter</h3>
              <p>Get the latest insights, analysis, and updates delivered to your inbox</p>
            </div>
            <div className="newsletter-right">
              <form
                className="newsletter-form"
                onSubmit={(event) => {
                  event.preventDefault();
                  setSubmitted(true);
                }}
              >
                <input
                  type="email"
                  placeholder="Enter your email address"
                  className="newsletter-input"
                  required
                />
                <button type="submit" className="newsletter-btn">
                  Subscribe
                </button>
              </form>
              {submitted && <p className="newsletter-note">Thank you. Your subscription request has been recorded.</p>}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Insights;
